import { Api } from "../ApiConfig"
import { ApiException } from "../ApiException"
import { getErrorMessage } from "../../../utils/utils"

export const startResourceAvailabilityImport = async (id: string) => { 
    try {
        const { data } = await Api.post(`api/ResourceAvailabilityImport/StartResourceAvailabilityImport/${id}`)
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao importar a Disponibilidade Padrão nos colaboradores'))
    }
}